import { useTranslations } from 'next-intl';
import { Text } from '@mentimeter/ragnar-ui/text';
import { Button } from '@mentimeter/ragnar-ui/button';
import { Box } from '@mentimeter/ragnar-ui/box';
import { useBillingHistory } from '@mentimeter/billing';
import { ErrorMessageWrapper } from './components/ErrorMessageWrapper';
import { ErrorMessageTitle } from './components/ErrorMessageTitle';

export const UnpaidInvoiceNoUpgrade = ({
  onClickPayNow,
}: {
  onClickPayNow: () => void;
}) => {
  const t = useTranslations('purchasing.legacy.checkoutUiPackage');
  const { receipts } = useBillingHistory(false);
  const invoice_url = receipts
    ? receipts.find((receipt) => receipt?.status === 'open')?.invoice_url
    : null;

  return (
    <ErrorMessageWrapper>
      <ErrorMessageTitle text={t('errors.unpaid_invoice_title')} />
      <Box gap="space5" alignItems="center">
        <Text textAlign="center" mt="space4" style={{ whiteSpace: 'pre' }}>
          {t('errors.unpaid_invoice_info')}
        </Text>
        <Button
          variant="primary"
          href={invoice_url ?? 'app/billing'}
          target="_blank"
          rel="noopener noreferrer"
          onClick={onClickPayNow}
        >
          {t('errors.unpaid_invoice_CTA')}
        </Button>
      </Box>
    </ErrorMessageWrapper>
  );
};
